/**
 * URL pública de mídia do FlowBuilder (img/audio/video).
 * Arquivos ficam em public/company{id}/flow/{arquivo}
 */
export function getFlowMediaPublicUrl(fileRef, companyId) {
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  if (!fileRef) return "";

  const ref = String(fileRef).trim();
  if (ref.startsWith("http://") || ref.startsWith("https://")) {
    return ref;
  }

  let pathPart = ref.replace(/^\/+/, "");
  if (pathPart.startsWith("public/")) {
    pathPart = pathPart.slice("public/".length);
  }

  if (pathPart.includes("/flow/") || /^company\d+\//.test(pathPart)) {
    return `${base}/public/${pathPart}`;
  }

  if (companyId != null && companyId !== "") {
    return `${base}/public/company${companyId}/flow/${pathPart}`;
  }

  return `${base}/public/${pathPart}`;
}

/** URLs para tentar no preview (flow/ e pasta antiga company/id/) */
export function getFlowMediaPublicUrlCandidates(fileRef, companyId) {
  const primary = getFlowMediaPublicUrl(fileRef, companyId);
  const candidates = [primary];
  const ref = String(fileRef || "").trim();
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

  if (
    companyId != null &&
    ref &&
    !ref.startsWith("http") &&
    !ref.includes("/flow/") &&
    !/^company\d+\//.test(ref)
  ) {
    const legacy = `${base}/public/company${companyId}/${ref.replace(/^\/+/, "")}`;
    if (legacy !== primary) {
      candidates.push(legacy);
    }
  }

  return candidates.filter(Boolean);
}

export default getFlowMediaPublicUrl;
